// import CustomButton from "Components/Custom/CustomButton";
// import Icon from "Components/Icons/Icon";
import CheckMarginModal from "Components/Modals/CheckMarginModal";
import React, { useState } from "react";
import { QuoteDetailsPayload } from "types/quote.api";
import { calculateMarginData } from "utils/utils";

interface QuoteSummaryTotalsProps {
  quotesDetails: QuoteDetailsPayload;
}

const QuoteSummaryTotals: React.FC<QuoteSummaryTotalsProps> = ({
  quotesDetails,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <div
      className="d-flex flex-column gap-2 ms-auto p-3"
      style={{ width: 300 }}
    >
      <CheckMarginModal
        isOpen={showModal}
        onClose={closeModal}
        items={quotesDetails?.items || []}
      />
      {/* <DiscountModal
        openDiscountModal={openAddDiscountModal}
        toggleDiscountModal={() => {
          setOpenAddDiscountModal((prev) => !prev);
        }}
        onAddDiscountClick={handleApplyDiscount}
      /> */}
      {/* Subtotal */}
      <div className="d-flex justify-content-between w-100 pb-1">
        <div className="text-grey89 fw-normal fs-14 font-primary">Subtotal</div>
        <div className="text-black2D fw-normal fs-14 font-primary">
          £{quotesDetails?.financial_summary?.sub_total.toFixed(2)}
        </div>
      </div>

      {/* Margin */}
      <div className="d-flex justify-content-between w-100">
        <div className="text-grey89 fw-normal fs-14 font-primary">
          Margin (
          {calculateMarginData(
            quotesDetails.items,
          ).totals.totalMarginPercent.toFixed(2)}
          %)
        </div>
        <button
          className="btn p-0 text-primary text-decoration-underline fs-14 font-primary"
          style={{ background: "none" }}
          onClick={openModal}
        >
          Check Margin
        </button>
      </div>

      {/* Tax */}
      <div className="d-flex justify-content-between w-100">
        <div className="text-grey89 fw-normal fs-14 font-primary">
          Tax ({quotesDetails.vat}%)
        </div>
        <div className="text-black2D fw-normal fs-14 font-primary">
          £{quotesDetails?.financial_summary?.tax.toFixed(2)}
        </div>
      </div>

      {/* Discount */}
      <div className="d-flex justify-content-between w-100">
        <div className="text-grey89 fw-normal fs-14 font-primary">
          Discount ({quotesDetails?.discount?.amount || 0}%)
        </div>
        £{quotesDetails.financial_summary.discount.toFixed(2)}
      </div>

      {/* Divider */}
      <div className="my-2 dashed" />

      {/* Grand Total */}
      <div className="d-flex justify-content-between w-100 mt-2">
        <div className="text-grey89 fw-medium fs-14 font-primary">
          Grand Total
        </div>
        <div className="text-black2D fw-medium fs-14 font-primary">
          £{quotesDetails?.financial_summary?.grand_total.toFixed(2)}
        </div>
      </div>


      {/* Divider */}
      <div className="my-2 dashed" />

      {/* Deposit Required */}
      {quotesDetails?.deposit_required && (
        <>
          <div className="d-flex justify-content-between w-100 mt-2">
            <div className="text-grey89 fw-normal fs-14 font-primary">
              {quotesDetails?.deposit_payment?.status === 'received' ? " Deposit Received" : " Deposit Required"}
            </div>
            <div className="d-flex align-items-center gap-1 text-black2D fw-normal fs-14 font-primary">
              £{quotesDetails?.deposit_amount?.toFixed(2) || "0.00"}
              {quotesDetails?.deposit_payment?.status === 'received' && <span style={{ color: "#22c55e", fontSize: "15px", lineHeight: 1 }}>✓</span>}
            </div>
          </div>

          <div className="d-flex justify-content-between w-100 mt-1">
            <div className="text-grey89 fw-normal fs-14 font-primary">
              Payment Method
            </div>
            <div className="text-black2D fw-normal fs-14 font-primary">
              {(() => {
                const method = quotesDetails.deposit_payment?.payment_method ?? quotesDetails.deposit_payment_method ?? "cash";
                return method.charAt(0).toUpperCase() + method.slice(1);
              })()}
            </div>
          </div>

          {/* {(quotesDetails.deposit_payment?.payment_method ?? quotesDetails.deposit_payment_method ?? "cash") === "cash" && (
            <div className="d-flex gap-2 mt-2 position-relative">
              <Icon name='InfoOrange' width={16} height={16} className="align-self-start position-absolute" />
              <span className="fs-14 text-orangeFF fw-normal text-start ms-4" >
                Cash or offline payments should be completed directly and are not processed online.
              </span>
            </div>
          )} */}
        </>
      )}
    </div>
  );
};

export default React.memo(QuoteSummaryTotals);
